export const AliceSkillNameArray = ['damage_level', 'critical_chance_level', 'extra_gold_level', 'aura_level'] as const;
export const BobSkillNameArray = ['damage_level', 'enrage_time', 'enrage_refresh'] as const;

export type AliceSkillName = (typeof AliceSkillNameArray)[number];
export type BobSkillName = (typeof BobSkillNameArray)[number];

export enum TutorialStep {
    INIT = -1,
    LOADED_BOOT = 1,
    LOADED_PRELOAD = 2,
    PLAYER_INITIALIZED = 3,
    LOADED_TUTORIAL = 4,
    // _1_FARM_BUILD = 5,
    _2_FIRST_ATTACK = 13,
    _3_FIRST_KILL = -2,
    DONE = -2,
    SKIP = 0
}

export type PaymentRecord = Record<number, any>

export type FriendClaimed = {
    hackneyId: string,
    claimedAt: number
}

export type PlayerProfile = {
    hackney_id: string;

    player_platform: PlayerPlatformRecord;

    player_wallet: PlayerCurrencies;

    hero_alice: Record<AliceSkillName, number>;
    hero_bob: Record<BobSkillName, number>;

    tutorial_step: number;

    current_enemy: CurrentEnemy;
    current_stage: number;
    current_chapter: ConfigChapter;

    score_weekly: number;

    completed_payments: PaymentRecord

    friends_claimed: Array<FriendClaimed>;

    updated: number;
    updated_energy: number;
};

export type PlayerCurrencies = {
    currency_soft: number;
    currency_hard: number;
    currency_energy: number;
    currency_token: number;
};

export type PlatformName = 'telegram';
export type PlayerPlatformProfile = {
    id: string;
    first_name: string;
};
export type PlayerPlatformRecord = Partial<Record<PlatformName, PlayerPlatformProfile>>;

export const playerConfigVoid: PlayerConfig = {
    enemies: {
        1: [
            { enemy_name: 'Card_1', enemy_alias: 'Ace of Hearts', is_boss: false, enemy_shift: { x: 100, y: 10 } },
            { enemy_name: 'Golem', is_boss: false, enemy_shift: { x: 100, y: 10 } },
            { enemy_name: 'Vines', is_boss: false, enemy_shift: { x: 100, y: 10 } },
            { enemy_name: 'Debris', is_boss: false, enemy_shift: { x: 100, y: 10 } },
            { enemy_name: 'Card_3', enemy_alias: 'Ace of Diamonds', is_boss: false, enemy_shift: { x: 100, y: 10 } },
            { enemy_name: 'Clocks', is_boss: false, enemy_shift: { x: 100, y: 10 } },
            { enemy_name: 'White Rabbit', is_boss: true, enemy_shift: { x: 100, y: 10 } },
        ],
        2: [
            { enemy_name: 'Crab', is_boss: false },
            { enemy_name: 'Card_2', enemy_alias: 'Two of Spades', is_boss: false },
            { enemy_name: 'Dagon', is_boss: false },
            { enemy_name: 'Fish', is_boss: false },
            { enemy_name: 'Seagul', enemy_alias: 'Seagull', is_boss: false },
            { enemy_name: 'Card_4', enemy_alias: 'Five of Spades', is_boss: false },
            { enemy_name: 'Walrus', is_boss: true },
        ],
        3: [
            { enemy_name: 'Butterfly', enemy_alias: 'Butterfly', is_boss: false, enemy_shift: { x: 80, y: 10 } },
            { enemy_name: 'Mushroom', enemy_alias: 'Mushroom', is_boss: false, enemy_shift: { x: 80, y: 10 } },
            { enemy_name: 'Snake', enemy_alias: 'Snake', is_boss: false, enemy_shift: { x: 10, y: 10 } },
            { enemy_name: 'Chess4', enemy_alias: 'King', is_boss: false, enemy_shift: { x: 80, y: 10 } },
            { enemy_name: 'Blighted_Beetles', enemy_alias: 'Centipede', is_boss: false, enemy_shift: { x: 80, y: 10 } },
            { enemy_name: 'Chess2', enemy_alias: 'Queen', is_boss: false, enemy_shift: { x: 80, y: 10 } },
            { enemy_name: 'Sludge_Snails', enemy_alias: 'Snail', is_boss: false, enemy_shift: { x: 80, y: 10 } },
            { enemy_name: 'Caterpillar', enemy_alias: 'Caterpillar', is_boss: true, enemy_shift: { x: 80, y: 10 } }
        ],
        4: [
            { enemy_name: 'Sonya', enemy_alias: 'Sonya', is_boss: false, enemy_shift: { x: 80, y: 10 } },
            { enemy_name: 'Key_1', enemy_alias: 'Key', is_boss: false, enemy_shift: { x: 80, y: 10 } },
            { enemy_name: 'Teapot', enemy_alias: 'Teapot', is_boss: false, enemy_shift: { x: 80, y: 10 } },
            { enemy_name: 'Sweet_monster', enemy_alias: 'Sweet Monster', is_boss: false, enemy_shift: { x: 80, y: 10 } },
            { enemy_name: 'Mad_hatter', enemy_alias: 'Mad Hatter', is_boss: true, enemy_shift: { x: 80, y: 10 } },
        ],
        5: [
            { enemy_name: 'Balls', enemy_alias: 'Balls', is_boss: false, enemy_shift: { x: 80, y: 10 } },
            { enemy_name: 'Key_2', enemy_alias: 'Key', is_boss: false, enemy_shift: { x: 80, y: 10 } },
            { enemy_name: 'cards', enemy_alias: 'cards', is_boss: false, enemy_shift: { x: 80, y: 10 } },
            { enemy_name: 'Tree', enemy_alias: 'Tree', is_boss: true, enemy_shift: { x: 80, y: 10 } },
        ],
        6: [
            { enemy_name: 'Skull', enemy_alias: 'Skull', is_boss: false, enemy_shift: { x: 80, y: 10 } },
            { enemy_name: 'Key_3', enemy_alias: 'Key', is_boss: false, enemy_shift: { x: 80, y: 10 } },
            { enemy_name: 'Wendigo', enemy_alias: 'Wendigo', is_boss: false, enemy_shift: { x: 80, y: 10 } },
            { enemy_name: 'Cheshire Cat', enemy_alias: 'Cheshire Cat', is_boss: true, enemy_shift: { x: 80, y: 10 } },
        ],
        8: [],
        9: [],
        7: [],
    },
    chapters: {
        1: {
            chapter_background: 'Hole',
        },
        2: {
            chapter_background: 'Sea',
        },
        3: {
            chapter_background: 'Forest',
        },
        4: {
            chapter_background: 'Table',
        },
        5: {
            chapter_background: 'QueensCroquetGrounds',
        },
        6: {
            chapter_background: 'CheshireCatForest',
        },
        8: {
            chapter_background: '',
        },
        9: {
            chapter_background: '',
        },
        7: {
            chapter_background: '',
        },
    },
    base_values: {
        one_energy_recovery_speed_in_msec: 60 * 1000,
        base_gold: 500,
        base_hp_enemy: 50,
        base_hp_boss: 250,
        base_reward_coins: 5,
        chapter_exponent_enemy: 1.8,
        chapter_exponent_boss: 2.1,
        stage_exponent: 1.4,
        alice_damage_upgrade_base: 50,
        alice_damage_upgrade_exp: 1.15,
        alice_damage_base: 2,
        alice_crit_chance_base: 0.04,
        alice_crit_chance_multiplication: 3,
        alice_crit_chance_base_cost: 100,
        alice_crit_chance_base_cost_multiplication: 1.2,
        alice_extra_gold_base_cost: 80,
        alice_extra_gold_multiplication: 1.18,
        alice_extra_gold_increment: 0.02,
    },
};

export const playerProfileStart: PlayerProfile = {
    hero_alice: {
        damage_level: 1,
        critical_chance_level: 1,
        extra_gold_level: 1,
        aura_level: 1
    },
    hero_bob: {
        damage_level: 1,
        enrage_time: 1,
        enrage_refresh: 1,
    },
    tutorial_step: -1,
    updated: Date.now(),
    hackney_id: '',
    player_platform: {
        telegram: {
            id: '0',
            first_name: 'Hack Ney Start',
        },
    },
    current_chapter: 1,
    score_weekly: 0,
    updated_energy: Date.now(),
    player_wallet: {
        currency_soft: 0,
        currency_hard: 0,
        currency_energy: 400,
        currency_token: 0,
    },
    completed_payments: [],
    friends_claimed: [],
    current_enemy: {
        enemy_name: 'Card_1',
        enemy_alias: 'Ace of Hearts',
        enemy_shift: { x: 100, y: 10 },
        is_boss: false,
        hp: 50,
        gold: 10
    },
    current_stage: 0
};

export type ConfigChapter = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
export type ConfigEnemiesChapterSpec = Array<ConfigEnemy>;

export type ConfigEnemiesChapterRecord = Record<ConfigChapter, ConfigEnemiesChapterSpec>;
export type ConfigEnemy = {
    enemy_name: string;
    enemy_alias?: string;
    enemy_shift?: { x: number; y: number };
    is_boss: boolean;
};
export type CurrentEnemy = ConfigEnemy & {
    hp: number;
    gold: number;
}
export type ConfigBaseValues = {
    one_energy_recovery_speed_in_msec: number;
    base_gold: number;
    base_hp_enemy: number;
    base_hp_boss: number;
    base_reward_coins: number;
    chapter_exponent_enemy: number;
    chapter_exponent_boss: number;
    stage_exponent: number;
    alice_damage_upgrade_base: number;
    alice_damage_upgrade_exp: number;
    alice_damage_base: number;
    alice_crit_chance_base: number;
    alice_crit_chance_multiplication: number;
    alice_crit_chance_base_cost: number;
    alice_crit_chance_base_cost_multiplication: number;
    alice_extra_gold_base_cost: number;
    alice_extra_gold_multiplication: number;
    alice_extra_gold_increment: number;
};

export type ConfigChapterSpec = { chapter_background: string };
export type ConfigChaptersRecord = Record<ConfigChapter, ConfigChapterSpec>;

export type PlayerConfig = {
    enemies: ConfigEnemiesChapterRecord;
    chapters: ConfigChaptersRecord;
    base_values: ConfigBaseValues;
};

export type ConfigLevel = number;
export type ConfigLevelSpec = {
    level_price: number;
    level_value: number;
};

export type LvlRecord = Record<ConfigLevel, ConfigLevelSpec>;

export type ConfigAlice = {
    [key in AliceSkillName]: LvlRecord;
} & { attack_speed: number };

export type ConfigBob = {
    [key in BobSkillName]: LvlRecord;
} & { attack_speed: number };

export type ServerResponse = {
    player: PlayerProfile;
    updated_previous?: number;
    afk_reward?: number,
    afk_time?: number,
    game_config?: PlayerConfig;
    shop?: ShopConfig;
    refs?: Array<HackneyGraphId>;
    nextEnemy?: CurrentEnemy;
};

export const ShopCurrencyNamesArray = ["soft_currency", "hard_currency", "telegram_stars"] as const;
export type ShopCurrency = typeof ShopCurrencyNamesArray[number];

export type ShopItem = {
    amount: number;
    id: string;
}
export type ShopPosition = {
    title: string,
    description: string,

    shop_id: string;

    price_currency: ShopCurrency;
    price_amount: number;

    items: Array<ShopItem>
}
export type ShopConfig = {
    offers: Array<ShopPosition>,
    gems: Array<ShopPosition>,
}
export type HackneyGraphId = {
    id: string;
    name: string;
    lastName?: string;
    createdAt: number;
    label: string;
}
export const voidShopConfig: ShopConfig = {
    offers: [{ title: '1', description: '1', shop_id: 'hard_2', price_currency: 'telegram_stars', price_amount: 20, items: [{ amount: 20, id: '22' }] }],
    gems: [{ title: '1', description: '1', shop_id: 'hard_2', price_currency: 'telegram_stars', price_amount: 20, items: [{ amount: 20, id: '22' }] }]
}